<template>
  <div class="platform-notifications-container" :class="{'sidebar': !$route.meta.hideSidebar, 'collapsed': getSidebarCollapsed}"
  :style="{'--collapse-transition-duration': `${getSidebarCollapseDuration}ms`}">
    <template v-for="notification in platformNotifications">
      <transition name="platform-notif">
        <div v-if="notification.isActive" :key="`notification-${notification.key}`"
        class="platform-notification flex items-center p-1 rounded-lg shadow-md">
          <div class="w-7 h-7 flex items-center justify-center">
            <component :is="notification.icon" class="text-white" />
          </div>
          <BaseText type="label" size="sm" class="text-white py-1 pl-1 pr-2">
            {{ notification.label }}
          </BaseText>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { platformNameMap, platformIconMap } from '@/utils/lens/dataSourceUtils'
import EventBus from './EventBus'

export default {
  name: 'BaseNotifyPlatformChange',
  data () {
    return {
      activePlatform: null,
      platformTimeout: null
    }
  },
  mounted () {
    EventBus.$on('showPlatformChange', (platform) => this.showPlatformChange(platform))
  },
  computed: {
    ...mapGetters('MiscModule', ['getSidebarCollapsed', 'getSidebarCollapseDuration']),
    platformNotifications () {
      return Object.entries(platformNameMap).map(([platformKey, platformName]) => ({
        key: platformKey,
        icon: platformIconMap[`mono-${platformKey}`],
        label: `Entering ${platformName} view mode`,
        isActive: this.activePlatform === platformKey
      }))
    }
  },
  methods: {
    showPlatformChange (platform) {
      clearTimeout(this.platformTimeout)
      this.activePlatform = platform
      this.platformTimeout = setTimeout(() => {
        this.activePlatform = null
      }, 2000)
    }
  }
}
</script>

<style scoped>
.platform-notifications-container {
  position: fixed;
  bottom: 16px;
  left: 32px;
  z-index: 500000;
  pointer-events: none;
  overflow: hidden;
  width: 400px;
  height: 52px;
  transition: transform var(--collapse-transition-duration) ease-in-out;
  transform: translateX(0px);
}
.platform-notifications-container.sidebar {
  left: 304px;
}
.platform-notifications-container.sidebar.collapsed {
  transform: translateX(-212px);
}
.platform-notification {
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: rgba(6, 7, 16, 0.92);
  backdrop-filter: blur(20px);
}

.platform-notif-enter-active, .platform-notif-leave-active {
  transition: transform 200ms ease-in-out, opacity 200ms ease-in-out;
}
.platform-notif-enter-from, .platform-notif-enter, .platform-notif-leave-to {
  opacity: 0;
}
.platform-notif-enter-from, .platform-notif-enter {
  transform: translateY(25%);
}
.platform-notif-enter-to, .platform-notif-leave-from {
  opacity: 1;
  transform: translateY(0%);
}
</style>